import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { APP_NAME } from "constants/app.constant";
import AutogonLogo from "assets/images/logo.jpg";
import AutogonLogo1 from "assets/images/logo2.png";
import AutogonLogo3 from "assets/logo2.png";
import AutogonLogo4 from "assets/images/logo3.png";
import { useSelector } from "react-redux";

const LOGO_SRC_PATH = "assets/images/";
// const LOGO_SRC_PATH = "/img/logo/";

const Logo = (props) => {
  const { type, mode, gutter, className, imgClass, style, logoWidth } = props;
  const auth = useSelector((state) => state.auth?.session);
  const sideNavCollapse = useSelector(
    (state) => state.theme.layout.sideNavCollapse
  );
  // console.log('user', auth)
  return (
    <div
      className={classNames("logo", className, gutter)}
      style={{
        ...style,
        ...{ width: logoWidth },
      }}
    >
      {/* <img 
				className={imgClass} 
				src={`${LOGO_SRC_PATH}logo-${mode}-${type}.png`} 
				alt={`${APP_NAME} logo`}
			/> */}
      <div
        className={`mt-8  text-white ${auth.signedIn ? "mb-4" : "text-center mb-2"}`}
      >
        {sideNavCollapse ? (
          <img
            src={ AutogonLogo4}
            alt="Autogon Logo"
            className={`w-3/4 max-w-[8rem]  ${auth.signedIn ? "" : "mx-auto"}`}
          />
        ) : (
          <img
            src={auth.signedIn ? AutogonLogo3 : AutogonLogo}
            alt="Autogon Logo"
            className={`w-2/3 max-w-[8rem]  ${auth.signedIn ? "" : "mx-auto"}`}
          />
        )}
      </div>
      {/* <h3 className="mt-8 text-white">Autogon</h3> */}
    </div>
  );
};

Logo.defaultProps = {
  mode: "light",
  type: "full",
  logoWidth: "auto",
};

Logo.propTypes = {
  mode: PropTypes.oneOf(["light", "dark"]),
  type: PropTypes.oneOf(["full", "streamline"]),
  gutter: PropTypes.string,
  imgClass: PropTypes.string,
  logoWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default Logo;
